module.exports = __webpack_public_path__ + "static/img/18041B_1_R_20200921_LC.5ac8126.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18041B_1_R_20200921_LC.png
// module id = mXcE
// module chunks = 0